"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackLoginClick = void 0;
const enums_1 = require("../enums");
const trackAnalyticsEvent_1 = require("./trackAnalyticsEvent");
const trackLoginClick = (clickText, clickUrl) => {
    (0, trackAnalyticsEvent_1.trackAnalyticsEvent)({
        category: enums_1.EventCategory.Wishlist,
        action: enums_1.EventAction.TextClick,
        label: enums_1.GA4EventLabel.LogIn,
        nonInteraction: false,
        eventData: {
            eventName: enums_1.GA4EventName.ClickTextLink,
            feature_category: enums_1.GA4FeatureCategory.Wishlist,
            click_element: enums_1.ClickElement.LogIn,
            click_text: clickText,
            click_url: clickUrl,
        },
    });
};
exports.trackLoginClick = trackLoginClick;
//# sourceMappingURL=trackLoginClick.js.map